import { render, staticRenderFns } from "./specialty-first.vue?vue&type=template&id=01d1a62e&scoped=true"
import script from "./specialty-first.vue?vue&type=script&lang=js"
export * from "./specialty-first.vue?vue&type=script&lang=js"
import style0 from "./specialty-first.vue?vue&type=style&index=0&id=01d1a62e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1a62e",
  null
  
)

export default component.exports